import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'components/Button/styles';

import * as S from './style';

import { ForwardAlertUnavailableProps } from './types';

const ForwardAlertUnavailable: React.FC<ForwardAlertUnavailableProps> = ({
  confirmedCriticality,
}) => {
  const handleConfirmedCriticality = () => {
    confirmedCriticality();
  };

  const intl = useIntl();

  return (
    <>
      <S.DrawerContentTitle data-testid="ForwardAlertUnavailableTitle">
        <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.FORWARDALERT.TITLE" />
      </S.DrawerContentTitle>
      <S.DrawerContentSubTitle>
        <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.FORWARDALERT.SUBTITLE" />
      </S.DrawerContentSubTitle>
      <S.DrawerContainerBox>
        <S.NotificationBox>
          <S.NotificationIcon />
          <S.NotificationText>
            <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.FORWARDALERT.UNAVAILABLE.NOTIFICATIONTEXT" />
          </S.NotificationText>
        </S.NotificationBox>

        <S.InformationText bold>
          <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.FORWARDALERT.UNAVAILABLE.NOT_PROFESSIONAL_EXTERNAL" />
        </S.InformationText>

        <S.InformationText>
          <FormattedMessage
            id="ENDUSER.DRAWER.CRITICAL.FORWARDALERT.UNAVAILABLE.INFORM_DIRECTLY"
            values={{
              criticalCasesProtocol: (
                <S.InformationLink
                  href={intl.formatMessage({
                    id: 'ENDUSER.DRAWER.CRITICAL.FORWARDALERT.UNAVAILABLE.INFORM_DIRECTLY.CRITICAL_CASES_PROTOCOL.URL',
                  })}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.FORWARDALERT.UNAVAILABLE.INFORM_DIRECTLY.CRITICAL_CASES_PROTOCOL" />
                </S.InformationLink>
              ),
              emailClinicalSupervision: (
                <S.InformationLink
                  href={`mailto:${intl.formatMessage({
                    id: 'ENDUSER.DRAWER.CRITICAL.FORWARDALERT.UNAVAILABLE.INFORM_DIRECTLY.EMAIL_CLINICAL_SUPERVISION',
                  })}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.FORWARDALERT.UNAVAILABLE.INFORM_DIRECTLY.EMAIL_CLINICAL_SUPERVISION" />
                </S.InformationLink>
              ),
            }}
          />
        </S.InformationText>
      </S.DrawerContainerBox>

      <S.DrawerBoxFooter>
        <Button onClick={handleConfirmedCriticality}>
          <FormattedMessage id="CONFIRM.CONFIRM.DEFAULT" />
        </Button>
      </S.DrawerBoxFooter>
    </>
  );
};

export default ForwardAlertUnavailable;
